import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <div className="hero-container">
            <h1>REMENA</h1>
            <p>AV-tuotantoja vuodesta 2015</p>
            <i>Sivuja uudistetaan parhaillaan</i>
        </div>
    );
};

export default Hero;